// @flow
import React, { useState } from 'react';
import { Link, useHistory } from "react-router-dom";
import { getRouteUrl } from "../../../helpers/getRouteUrl";
import { useTranslation } from "react-i18next";
import {
	Box,
	Button,
	Typography,
	Card,
	CardContent,
	Grid,
} from '@mui/material';
import { PAGE_HOME } from "../../../locales/pages/namespaces";
import { ROUTE_PAGE_CALCULATIONS_CREATE } from "../../../modules/calculations/routes/routes";
import IndexListCalculations from "../../../modules/calculations/components/indexList/indexList";
import IndexListLoans from "../../../modules/loans/components/indexList/indexListLoans";
import { useMuiGridServerSide } from "../../../hooks/useMuiGridServerSide";
import { mapLoan } from "../../../modules/loans/types/map";
import { ROUTE_PAGE_WIZARD } from "../../../routers/routes";
import PlusIcon from "../../../../src/assets/images/icons/buttonsIcons/plusIcon";
import { showPopup } from '../../../components/globalPopup/globalPopupService';

const CustomerDashboard = () => {
	const { t } = useTranslation(PAGE_HOME)
	const history = useHistory();
	const url = `loan/indexTable/data`

	const { data } = useMuiGridServerSide({
		url,
		initialPageSize: 50,
		initialSortModel: [{ name: 'id', direction: 'descending' }],
		mapFunction: mapLoan
	})
	const activeLoans = data?.filter((loan) => loan?.ActiveStatus === "1") ?? []
	const hasActiveLoans = activeLoans?.length > 0


	return (
		<Box>


			<Grid container alignItems="center" justifyContent="space-between" 
				sx={{ margin:{xs:'18px 0 10px 0', sm:'40px 0 10px 0', md:'40px 0 10px 0'}}}
			>
				<Grid item xs={7} sm={7} md={6} lg={6}>
					<Typography className='title-xsm color-default' sx={{ marginLeft:'12px', fontSize:{xs:'18px !important',sm:'22px !important'}  }}>
						{t('My loans')}
					</Typography>
				</Grid>
				<Grid item>
					<Button
						size={"small"}
						variant={"contained"}
						color={'info'}
						sx={{ textAlign: 'center', padding: { xs: '12px' }, minWidth: { xs: 'inherit' } }}
						onClick={() => {
							if (hasActiveLoans) {
								showPopup({
								title: t("Loan Request"),
								message: t(
									"You already have an active loan. Are you sure you want to proceed with creating a new one?",
								),
								cancel: t("No"),
								ok: t("Yes"),
								onConfirm: () => {
									history.push(getRouteUrl(ROUTE_PAGE_WIZARD));
								},
								cancelClassName: 'btn-popup-secondary',
								});
							} else {
								history.push(getRouteUrl(ROUTE_PAGE_WIZARD));
							}
							}}
					>
						<PlusIcon/> <Box component="span" sx={{ marginLeft: '10px', display: { xs: 'none', sm: 'inline' } }}>{t('Loan Request')}</Box>
					</Button>
				</Grid>
			</Grid>



			<Box>
				<IndexListLoans data={data} />
				{data.length <= 0 &&
					<Box>
						<Card sx={{ mt: { xs: '10px', sm: 0 }   }}>
							<CardContent>
								<Typography style={{ textAlign: 'center' }}>
									{t('No loan request has been registered yet.')}
								</Typography>
							</CardContent>
						</Card>
					</Box>
				}
			</Box>




			<Box sx={{ mt: 2 }}>
				<Grid container alignItems="center" justifyContent="space-between" sx={{ margin:{xs:'18px 0 10px 0', sm:'40px 0 10px 0', md:'40px 0 10px 0'}}}>
					<Grid item xs={7} sm={7} md={6} lg={6}>
						<Typography className='title-xsm color-default' sx={{ marginLeft:'12px', fontSize:{xs:'18px !important',sm:'22px !important'}  }}>
							{t('My calculations')}
						</Typography>
					</Grid>
					<Grid item>
						<Button
							size={"small"}
							variant={"contained"}
							color={'info'}
							sx={{ textAlign: 'center', padding: { xs: '12px' }, minWidth: { xs: 'inherit' } }}
							component={Link}
							to={getRouteUrl(ROUTE_PAGE_CALCULATIONS_CREATE)}
						>
							<PlusIcon /><Box component="span" sx={{ marginLeft: '10px', display: { xs: 'none', sm:'inline' } }}>{t('Add loan scenario')}</Box>
						</Button>
					</Grid>
				</Grid>
				<IndexListCalculations gridItems='3'/>
			</Box>



		</Box>
	)
}

export default CustomerDashboard